import { styled, Typography, Row, Column } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const PositionLabel = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.medium};
  font-size: 0.75rem !important;
`;

export const Item = styled(Row)`
  position: relative;
  width: 100%;
  margin-left: 0;
  padding: 16px 0;

  &.product-list-item {
    width: calc(100% - 2rem);
  }

  && {
    margin-top: ${({ theme }) => `-${theme.spacing.nano}`};
  }
`;

export const Image = styled.img`
  width: 80px;
  height: 80px;
  margin-top: 5px;
  object-fit: cover;
  font-size: 12px;
  border-radius: ${({ theme }) => theme.border.radius.xs};
`;

export const ProductDetailLine = styled.div`
  display: flex;
  align-items: center;

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-flow: column;
      align-items: flex-start;
    }
  `}
`;

export const ProductId = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.medium};
  && {
    margin-right: ${({ theme }) => theme.spacing.xxxs};
  }
`;

export const Price = styled(Typography)`
  color: ${({ theme }) => theme.feedbackColor.positive.dark};
`;

export const ProductDetail = styled(Column)`
  width: calc(100% - 96px);
  overflow: hidden;
  margin-left: ${({ theme }) => theme.spacing.inline.nano};

  && {
    padding: 0;
    p {
      line-height: 150%;
    }
  }
`;

export const ProductTitle = styled(Typography)`
  &&& {
    line-height: 185%;
  }
  ${({ theme }) => css`
    @media only screen and (min-width: ${theme.breakpoints.md}) {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: calc(100% - 50px);
    }
  `}
`;

export const ContentProduct = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-flow: wrap;
  flex: 1;
  ${({ theme }) => css`
    @media only screen and (min-width: ${theme.breakpoints.md}) {
      overflow-x: hidden;
    }
  `}
`;

export const ContentRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      flex-flow: row wrap;
    }
  `}
`;
